/**
 * Card Product Swiper
 * Initializes Swiper sliders on product cards in collection/featured grids.
 * Each card with [data-card-swiper] gets its own Swiper instance.
 *
 * NOTE: loop is disabled on purpose. Swiper's loop mode clones slides into the
 * DOM, which made the same image appear repeatedly on cards with only a few
 * real slides. With loop: false the carousel steps through unique media only.
 */

if (!customElements.get('card-swiper')) {
  class CardSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    connectedCallback() {
      // Wait for Swiper to be available (loaded async)
      if (typeof Swiper === 'undefined') {
        document.addEventListener('swiper:loaded', () => this.init());
        return;
      }
      this.init();
    }

    init() {
      if (this.swiper) return;

      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        grabCursor: true,
        watchOverflow: true, // Disable if only 1 slide
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        // Prevent Swiper from hijacking vertical scroll
        threshold: 10,
        touchAngle: 45,
        // Lazy loading works with Shopify's native loading="lazy"
        preloadImages: false,
      });

      // Stop click event from bubbling to the card link when interacting with swiper
      swiperEl.addEventListener('click', (e) => {
        if (e.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination')) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('card-swiper', CardSwiper);
}
